// extracted by mini-css-extract-plugin
module.exports = {"container":"HomeSerious_container__1Kv7X"};